import { logoGJ, logoHansefit, logoRTL, logoSwissLife } from 'images/landingpages/b2b_landingpage/logos_mixed_coops';

export const businessCooperations = [
  {
    name: 'G+J',
    cooperationLogo: logoGJ
  },
  {
    name: 'Hansefit',
    cooperationLogo: logoHansefit
  },
  {
    name: 'SwissLife',
    cooperationLogo: logoSwissLife
  },
  {
    name: 'RTL',
    cooperationLogo: logoRTL
  }
];
